import React from "react";

import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";

import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";

import { useBnbSelector } from "../../../redux/store";
import type { GradeInteriorModalType } from "../../../utils/modalConstants";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { BnbLabel } from "../../../utils/labels";
import { isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import useWebGLSupportLevel from "../../../hooks/customize/useWebGLSupportLevel";
import InteriorSpin3D from "../common/interior/InteriorSpin3D";
import InteriorGallery from "../common/interior/InteriorGallery";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { show3dSpin } from "../../../../../shared-logic/utils/imageUtils";

const GradeInteriorModal = (props: ModalViewType<GradeInteriorModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const model = useBnbSelector((state) => state.model);
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    // both 3d spins
    const webGLSupportLevel = useWebGLSupportLevel();
    const enable3dSpin = show3dSpin(commonSettings, model.configVersion) && webGLSupportLevel > 1;
    const { id, name, bodyType } = modalSettings.grade;

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="interior" />
                    <div>
                        <Type.ModelName>{model.name}</Type.ModelName>
                        <Type.GradeName ml={isRTL(commonSettings) ? 0 : 1} mr={isRTL(commonSettings) ? 1 : 0}>
                            {name}
                        </Type.GradeName>
                    </div>
                    {bodyType.name && <Type.SmallHeading>{bodyType.name}</Type.SmallHeading>}
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Flex.Row>
                    {enable3dSpin ? (
                        <InteriorSpin3D visible getByFrame gradeId={id} bodyTypeId={bodyType.id} />
                    ) : (
                        <InteriorGallery getByFrame gradeId={id} bodyTypeId={bodyType.id} />
                    )}
                </Flex.Row>
            </Modal.Body>
        </ModalBaseView>
    );
};
export default GradeInteriorModal;
